"use strict";var e=require("@apollo/client").gql`
  query GetCountry($name: String!) {
    getCountry(name: $name) {
      currency
    }
  }
`;exports.g=e;